<template>
  <div class="row">
    <LeadLink
      :in-new-tab="true"
      :call-target-id="callTargetId"
      class="lead-link"
    >
      <span class="company-name">{{ companyName }}</span>
      <span class="full-name">{{ fullName }}</span>
      <span class="error-message">{{ errorMessage }}</span>
    </LeadLink>
  </div>
</template>


<script lang="ts" setup>
import LeadLink from '@/components/organisms/user/general/LeadLink.vue';

type TProps = {
  callTargetId: number;
  companyName: string;
  fullName: string;
  errorMessage: string;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.lead-link {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  color: $textcolor-base;
  text-decoration: none;
  min-height: 34px;

  &:hover {
    background-color: $bgcolor-base;
  }

  .company-name {
    width: 160px;
  }

  .full-name {
    width: 120px;
  }
}
</style>
